// src/pages/ContentEditor/components/tabs/FluencyTab.js
import React from 'react';
import { Box, Typography, Button, Card, CardContent, IconButton, TextField, alpha } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const FluencyTab = ({ paragraphs, onNestedChange, onAddItem, onRemoveItem }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" color="text.primary">
          Fluency Text
        </Typography>
        
        <Button
          startIcon={<AddIcon />}
          onClick={onAddItem}
          sx={{ color: theme.palette.primary.main }}
        >
          Add Paragraph
        </Button>
      </Box>
      
      {paragraphs.map((paragraph, index) => (
        <Card 
          key={index} 
          variant="outlined" 
          sx={{ 
            mb: 3, 
            backgroundColor: theme.palette.background.paper,
            borderColor: alpha(theme.palette.common.white, 0.1),
            '&:hover': {
              borderColor: theme.palette.primary.main,
            }
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={500} color="text.primary">
                Paragraph {index + 1}
              </Typography>
              
              <IconButton 
                color="error" 
                onClick={() => onRemoveItem(index)}
                disabled={paragraphs.length <= 1}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
            
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              placeholder="Enter fluency paragraph text..."
              value={paragraph.text}
              onChange={(e) => onNestedChange('fluencyActivity', index, 'paragraph', e.target.value)}
              InputProps={{ style: { color: theme.palette.text.primary } }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: alpha(theme.palette.common.white, 0.2),
                  },
                  '&:hover fieldset': {
                    borderColor: alpha(theme.palette.common.white, 0.3),
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                  backgroundColor: alpha(theme.palette.common.white, 0.05)
                }
              }}
            />
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default FluencyTab;




